<div
  class="admission-status-bar mu-bg-danger"
  *ngIf="regStatus === '1' || regStatus === '5'"
>
  <fa-icon [icon]="faInfo" class="mu-px2"></fa-icon>
  {{ 'status.' + (subStatus() || 'approved') | translate }}
  <ng-container *ngIf="subStatus() != 'withdrawn'">
    <a class="open-message-center" (click)="openMessageCenter()">
      {{ 'message-center.messages' | translate }}
    </a>
    {{ 'status.more' | translate }}
  </ng-container>
</div>
